import { render, staticRenderFns } from "./InstrumentHistogramBlock.vue?vue&type=template&id=03186190&scoped=true"
import script from "./InstrumentHistogramBlock.vue?vue&type=script&lang=js"
export * from "./InstrumentHistogramBlock.vue?vue&type=script&lang=js"
import style0 from "./InstrumentHistogramBlock.vue?vue&type=style&index=0&id=03186190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03186190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VRow,VSpacer})
